import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)``;

export const Indicator = styled.div`
  grid-row: 1 / 1;
  grid-column: 1 / 1;

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  inline-size: 23px;
  block-size: 23px;

  color: #666666;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-align: center;

  background-color: #e5e5e5;
`;

export const Headline = styled.div`
  grid-row: 1 / 1;
  grid-column: 2 / 2;

  color: #999999;
  font-weight: normal;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;

  &:hover {
    color: #2c4692;
  }
`;

export const StyledBaseImage = styled(BaseImage)`
  grid-row: 2 / 2;
  grid-column: 2 / 2;

  padding-block: 8px 24px;

  background-color: transparent;
`;

export const ItemContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 31px auto;
`;

type ContainerProps = {
  $isActive?: boolean;
};

export const Container = styled.div<ContainerProps>`
  ${StyledEntityLink} {
    ${props =>
      props.$isActive
        ? css`
            cursor: unset;

            pointer-events: none;
          `
        : null}
  }

  ${Indicator} {
    ${props =>
      props.$isActive
        ? css`
            color: #ffffff;

            background-color: #000000;
          `
        : null}
  }

  ${Headline} {
    ${props =>
      props.$isActive
        ? css`
            color: #000000;
          `
        : null}
  }
`;
